import { m, type MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';
import { ColorPalette2022Branding } from '../theme.palette';

export const CSS = {
	redDot: 'c-RedDot',
	redDotOverlay: 'c-RedDot--overlay',
};

const Style = {
	[CSS.redDot]: {
		display: 'inline-block',
		background: ColorPalette2022Branding.lightRed,
		'border-radius': '50%',
		width: '8px',
		height: '8px',
		'pointer-events': 'none',
	},
	[CSS.redDotOverlay]: {
		position: 'absolute',
		top: '4px',
		right: '4px',
	},
};

addStyles(Style);

export interface RedDotOptions {
	/** When true, positions the dot absolutely at top-right (parent must be position: relative) */
	overlay?: boolean;
	/** Extra class name appended to the dot span */
	className?: string;
}

export function redDot(options: RedDotOptions = {}): MithrilVNode {
	const classes = [CSS.redDot];
	if (options.overlay) {
		classes.push(CSS.redDotOverlay);
	}
	if (options.className) {
		classes.push(options.className);
	}
	return m('span', { className: classes.join(' ') });
}
